/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */
import { Directive, AfterViewInit, OnDestroy, ElementRef, Input } from '@angular/core';
import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { NvFocusTrap, NvFocusTrapFactory } from '../services/focus-trap';
import { SpatialNavigationService } from '../services/spatial-navigation/spatial-navigation.service';

@Directive({
    selector: '[nvTrapFocus]',
    standalone: true
})
export class TrapFocusDirective implements AfterViewInit, OnDestroy {
    @Input()
    get forceEnable() {
        return this._forceEnable;
    }
    set forceEnable(value: BooleanInput) {
        this._forceEnable = coerceBooleanProperty(value);
    }
    private _forceEnable = false;
    private focusTrap?: NvFocusTrap;

    constructor(
        private elementRef: ElementRef<HTMLElement>,
        private spatialNavigationService: SpatialNavigationService,
        private nvTrapFocusFactory: NvFocusTrapFactory
    ) {}

    ngAfterViewInit() {
        if (this.elementRef && (this.forceEnable || this.spatialNavigationService.enabled)) {
            this.focusTrap = this.nvTrapFocusFactory.create(this.elementRef.nativeElement);
            this.focusTrap.attach();
        }
    }

    ngOnDestroy() {
        if (this.focusTrap?.isAttached) {
            this.focusTrap?.detach();
        }
    }
}
